import { render, staticRenderFns } from "./PaymentHandler.vue?vue&type=template&id=0f66932e&scoped=true"
import script from "./PaymentHandler.vue?vue&type=script&lang=ts"
export * from "./PaymentHandler.vue?vue&type=script&lang=ts"
import style0 from "./PaymentHandler.vue?vue&type=style&index=0&id=0f66932e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66932e",
  null
  
)

export default component.exports